import { BookIntervalCode } from "@/types";
import { ILineFareInfo } from "./lineInfo.types";

export class LineFare implements ILineFareInfo {
  readonly fareAmount: number;
  readonly bookIntervalCode: BookIntervalCode; // BDT-MONTH
  readonly name?: string;
  readonly code?: string;
  readonly displayOrder?: number;

  constructor(data: ILineFareInfo) {
    this.fareAmount = data.fareAmount;
    this.bookIntervalCode = data.bookIntervalCode;
    this.name = data.name;
    this.code = data.code;
    this.displayOrder = data.displayOrder;
  }
}
